module.exports = __webpack_public_path__ + "img/kmlookbook12web.e113a9b7.jpg";